import { useCoreApiClient } from "@api/use-core-api-client";
import { useAppParams } from "@router/router-helper";
import { SphereDashboardAPITypes } from "@stellar/api-logic";
import { useEffect, useState } from "react";

interface ReturnProps {
  /** All the Stripe products in the company */
  stripeProducts: SphereDashboardAPITypes.StripeProduct[];

  /** Whether the Stripe products are still being loaded */
  isLoading: boolean;
}

/** A hook that fetches all the Stripe products in the company */
export function useStripeProducts(): ReturnProps {
  const coreApiClient = useCoreApiClient();
  const { companyId } = useAppParams();

  const [stripeProducts, setStripeProducts] = useState<SphereDashboardAPITypes.StripeProduct[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  // Fetch all the Stripe products in the company
  useEffect(() => {
    async function fetchStripeProducts(): Promise<void> {
      if (companyId) {
        const products = await coreApiClient.V3.SDB.getStripeProducts(companyId);

        if (products && products.length > 0) {
          setStripeProducts(products);
        }

        setIsLoading(false);
      }
    }
    void fetchStripeProducts();
  }, [companyId, coreApiClient]);

  return { stripeProducts, isLoading};
}